"use client";

import { ReactNode } from "react";
import { useAuth } from "./auth-provider";

interface RequirePlatformAdminProps {
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Renders children only for platform admins. Orthogonal to role — used for
 * platform-exclusive actions like API key creation, transfer, tenant lifecycle.
 */
export function RequirePlatformAdmin({ fallback = null, children }: RequirePlatformAdminProps) {
  const { user } = useAuth();
  if (!user?.is_platform_admin) return <>{fallback}</>;
  return <>{children}</>;
}
